<template>
  <div>
    <v-btn fab color="primary" dark @click.stop="dialog = true">
      <v-icon>help</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">Bảng mô tả màu sắc và trạng thái</v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-chip class="ma-2" color="error" text-color="white">Mới (cần được điều phối)</v-chip>
            <v-chip class="ma-2" color="deep-purple lighten-2" text-color="white">Hẹn lại</v-chip>
            <v-chip class="ma-2" color="success" text-color="white">Đã hoàn thành (chưa đóng)</v-chip>
            <v-chip class="ma-2" color="orange" text-color="white">Đang thực hiện</v-chip>
            <v-chip class="ma-2" color="grey" text-color="white">Đã hoàn thành và đã đóng</v-chip>
            <v-chip class="ma-2" color="blue" text-color="white">Chưa thực hiện</v-chip>
            <v-chip class="ma-2" color="pink darken-1" text-color="white">Chờ xe</v-chip>
            <v-chip class="ma-2" color="indigo darken-3" text-color="white">Gia hạn</v-chip>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/DispatchHelp.vue